export const contentData = {
  spanish:{
    layout:{
      title:'Facturación',
      navigation:[
        {name:'Clientes',path:'/clients'},
        {name:'Detalles',path:'/clients/details/:id'},
        {name:'Negocios',path:'/clients/details/:id/businesses'},
        {name:'Detalles',path:'/clients/details/:id/businesses/:idbusiness'},
        {name:'Servicio',path:'/clients/details/:id/businesses/:idbusiness/service/:idservice'},
      ],
      menu:[
        {id:0, label:'General'},
        {id:1, label:'Cuentas Sicofi'},
        {id:2, label:'Sucursal'},
        {id:3, label:'Logs'}
      ]
    },
    modals:{
      warning_delete_file:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      edit_service:{
        title:'Editar servicio',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
    basicform:{
      title:'Información Básica',
      button:'Editar',
      nodata:'Sin Registro',
      data:{
        rfc:{
          label:'',
          data:'',
        },
        billing_option:{
          label:'',
          data:'',
        },
        billing_stamps_limit:{
          label:'',
          data:'',
        },
        billing_responsible:{
          label:'',
          data:''
        }
      },
      content:{
        rfc:{
          label:'RFC'
        },
        efirma_password:{
          label:'Contraseña eFirma'
        },
        billing_option:{
          label:'Opción de facturación'
        },
        billing_stamps_limit:{
          label:'Número de estampados'
        },
        billing_responsible:{
          label:'Responsable de facturación'
        }
      },
      documents:{
        title:'Documentos',
        header:{title:'Archivos', actions:'Acciones'},
        files:[
          {key:'product_catalog',name:'Catálogo del  Producto',path:'productcatalog', status:false},
          {key:'logo',name:'Logotipo',path:'logo', status:false},
        ]
      }
    }
  }
}